import { render, staticRenderFns } from "./AppointmentsRecords.vue?vue&type=template&id=f544eb32"
import script from "./AppointmentsRecords.vue?vue&type=script&lang=js"
export * from "./AppointmentsRecords.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsRecords.vue?vue&type=style&index=0&id=f544eb32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports